let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a9fOo")).then(() => parcelRequire('ikoZN'));